


// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// // Models
import { TypeOfProduct } from '@/manager/product/models/product.model';
import { BudgetLine } from '@/manager/budget/models/budget-line.model';

// Components
import Field from '@/shared/components/field.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import FlatSelectorText, {
    FlatSelectorTextPredefinedStyle,
    FlatSelectorTextBorderBottom,
    FlatSelectorTextWeight,
} from '@/shared/components/FlatSelectorText.component.vue';
import NumberPicker, {
    NumberPickerColor,
    NumberPickerSize,
} from '@/shared/components/number-picker.component.vue';
import Input, { InputType } from '@/shared/components/input.component.vue';


@Component({
    components: {
        Field,
        FlatSelectorText,
        Icon,
        NumberPicker,
        Input
    },
    computed: {
        ...mapGetters({
            getProfile: 'getProfile',
            getProduct: 'getProduct',
            productList: 'getProductBudgetableList',
            currentBudget: 'getCurrentBudget',
            lastLineEmpty: 'currentBudgetHasLastLineEmpty',
        }),
    },
})
export default class ShoppingCartLineBudget extends Vue {
    @Prop() private budgetLine!: any;
    @Prop({ default: false }) private modifyDataPrivate!: boolean;

    private iconEnum = IconEnum;
    private inputType = InputType;
    private flatSelectorTextBorderBottom = FlatSelectorTextBorderBottom;
    private flatSelectorTextWeight = FlatSelectorTextWeight;
    private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
    private numberPickerColor = NumberPickerColor;
    private numberPickerSize = NumberPickerSize;
    private productSelected: any = { label: '', value: '' };
    private productList!: any;
    private getProduct!: any;
    private currentBudget!: any;
    private lastLineEmpty!: any;
    private customBudgetTotal: any = 0;
    private searchTimeout: any = null
    

    get budgetHasProduct() {
        return this.budgetLine.product && this.budgetLine.product.id;
    }

    get budgetLineTotalPrice() {
        let price = 0;
        if (this.budgetHasProduct) {
            if (this.customBudgetTotal) {
                this.budgetLine.pricingApplied = this.customBudgetTotal
            }
            price = this.budgetLine.amount * ((this.budgetLine as any).pricingApplied || 0);
            this.budgetLine.totalPricingApplied = price;
        } 
        
        return price;
    }

    get budgetLinePaymentPending() {
        let paymentPeding = 0;
        if (this.budgetHasProduct) {
            paymentPeding = this.budgetLineTotalPrice - this.budgetLineReserve;
            this.budgetLine.totalPrice = paymentPeding;
        }
        return paymentPeding;
    }

    get budgetLineReserve() {
        let reserve = 0;
        if (this.budgetHasProduct) {
            reserve = this.budgetLine.amount * (this.budgetLine as any).product.reserve;
            this.budgetLine.totalPrepaidPrice = reserve;
        }
        return reserve;
    }

    get lineComplete() {
        return (
            this.budgetLine.product &&
            this.budgetLine.product.id &&
            (this.budgetLine as any).amount > 0
        );
    }


    private removeLine() {
        this.$emit('remove-line', this.budgetLine);
    }

    private addNewBudgetLine() {
        if (!this.lastLineEmpty) {
            this.$emit('new-line');
        }
    }

    private changeOption(option: any) {
        this.budgetLine.amount = 1;
        this.addNewBudgetLine();
    }

}
